import { useQuery } from '@apollo/client'
import { GetPrice, GetPriceVariables } from '../../types'
import { GET_COMPANY_PRICE } from './operations'

interface Props {
  companyId: string
  groupId?: string
  onCompleted?: (data: GetPrice) => void
}

export const useGetCompanyPrice = ({ companyId, groupId, onCompleted }: Props) =>
  useQuery<GetPrice, GetPriceVariables>(GET_COMPANY_PRICE, {
    variables: {
      inputData: {
        companyId: companyId,
        groupId: groupId,
      },
    },
    onCompleted,
  })
